import React, { useEffect } from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { appUrl } from '../utils/setup'
import AuthView from '../views/auth'
import HomeView from '../views/home'
import EventDetail from '../views/event-detail'
import { getSessionCustomer } from '../context/slices/session-customer'
import { useDispatch, useSelector } from 'react-redux'
import CartView from '../views/cart'
import LoadingIcon from '../components/loading/LoadingIcon'
import CartSuccess from '../views/cart/components/CartSuccess'
import CartError from '../views/cart/components/CartError'
import Us from '../views/home/Us'
import Contact from '../views/home/Contact'
import CustomerAuth from '../views/customer-auth'
import MetaPixelPageView from '../components/meta-pixel/MetaPixelPageView'

const RoutesNotAuthenticated = () => {

  const dispatch = useDispatch();
  const { id_customers_reservation_event_zone } = useSelector(state => state.sessioncustomer)
  const { sessionValidated, type, isCustomer } = useSelector(state => state.session)

  useEffect(() => {
    if (!(sessionValidated && isCustomer)) {
      dispatch(getSessionCustomer());
    }
  }, [dispatch, sessionValidated, isCustomer, type])

  if (!id_customers_reservation_event_zone) {
    return <LoadingIcon />
  }

  return <BrowserRouter>
    <MetaPixelPageView />
    <Switch>
      <Route path={appUrl({
        url: '/login'
      })} exact>
        <AuthView />
      </Route>
      <Route path={appUrl({
        url: '/cuenta/login'
      })} exact>
        <CustomerAuth />
      </Route>
      <Route path={appUrl({
        url: '/cuenta/registro'
      })} exact>
        <CustomerAuth />
      </Route>
      <Route path={appUrl({
        url: '/'
      })} exact>
        <HomeView />
      </Route>
      <Route path={appUrl({
        url: '/evento/:slugEvent/:zoneId?'
      })} exact>
        <EventDetail />
      </Route>
      <Route path={appUrl({
        url: '/carrito'
      })} exact>
        <CartView />
      </Route>
      <Route path={appUrl({
        url: '/carrito/success'
      })} exact>
        <CartSuccess />
      </Route>
      <Route path={appUrl({
        url: '/carrito/error-pago'
      })} exact>
        <CartError />
      </Route>
      <Route path={appUrl({
        url: '/nosotros'
      })} exact>
        <Us />
      </Route>
      <Route path={appUrl({
        url: '/contacto'
      })} exact>
        <Contact />
      </Route>
      <Route>
        <Redirect to={appUrl({
          url: '/'
        })} />
      </Route>
    </Switch>
  </BrowserRouter>
}

export default RoutesNotAuthenticated